// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"147":"67238c49739e5f63","408":"df1a998b5b577ee2","916":"eb5fefa2ab7f0fe1"}[chunkId] + ".js";
};